export const siteQuery = `
    query site {
        digistormComponents
        siteDetails
        colorThemes {
            id
            title
            defaultTheme
            themeData
        }
        entries(section: "ds_Pages", level: 1, pageVisibility: ["visible", "hideFromSearch"]) {
            id
            uri
            title

            children(pageVisibility: ["visible", "hideFromSearch"]) {
                id
                uri
                title
                children(pageVisibility: ["visible", "hideFromSearch"]) {
                    id
                    uri
                    title
                    ...on ds_RedirectPage_Entry {
                        redirectLink {
                            linkUrl
                            target
                        }
                    }
                }
                ...on ds_RedirectPage_Entry {
                    redirectLink {
                        linkUrl
                        target
                    }
                }
            }
            # this needs to be after childen otherwise it will not work
            ...on ds_RedirectPage_Entry {
                redirectLink {
                    linkUrl
                    target
                }
            }
        }
        globalSets {
            __typename
        }
    }
`